module.exports = __webpack_public_path__ + "static/media/argon-react.f38ddea9.png";